import type { ReactNode } from 'react';
import styles from './EmptyState.module.css';

export interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  size?: 'sm' | 'md';
  reserveSpace?: boolean;
}

export function EmptyState({ icon, title, description, action, size = 'md', reserveSpace = false }: EmptyStateProps) {
  const classes = [styles.root, styles[size], reserveSpace ? styles.reserveSpace : ''].filter(Boolean).join(' ');
  return (
    <div className={classes}>
      {icon && <div className={styles.icon}>{icon}</div>}
      <p className={styles.title}>{title}</p>
      {description && <p className={styles.description}>{description}</p>}
      {action && <div className={styles.action}>{action}</div>}
    </div>
  );
}
